<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>Easing Effects</h1>
					<p waBody="m" waText>33 easing timing functions from easings.net &mdash; smooth, natural CSS/JS animations with a type-safe Java enum API. Covers Quad, Cubic, Quart, Quint, Expo, Sine, Circ, Elastic, Back, and Bounce families with In/Out/InOut variants plus Linear and Swing.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Easing 1.4.1</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:easing-effects</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.easingeffects</p>
					<p waBody="s" waText>Built on: Easing / easings.net 1.4.1</p>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>INSTALLATION</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
						<markdown [data]="mdContent_88" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
						<markdown [data]="mdContent_89" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>NPM DEPENDENCIES &#40;auto-included&#41;</div>
					<markdown [data]="mdContent_90" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>COMPONENTS</div>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JQEasingEffects</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of 33 easing timing functions &mdash; Quad, Cubic, Elastic, Bounce, etc.</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.plugins.easingeffects</div>
							</div>
						</wa-card>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>FEATURES</div>
					<p waBody="s" waColorText="quiet" waText>33 easing timing functions &mdash; complete library from easings.net</p>
					<p waBody="s" waColorText="quiet" waText>Type-safe Java enum API &mdash; JQEasingEffects with compile-time safety and IDE autocomplete</p>
					<p waBody="s" waColorText="quiet" waText>Animation categories &mdash; Quad, Cubic, Quart, Quint, Expo, Sine, Circ, Elastic, Back, Bounce</p>
					<p waBody="s" waColorText="quiet" waText>In/Out/InOut variants &mdash; each timing function includes ease-in, ease-out, and ease-in-out</p>
					<p waBody="s" waColorText="quiet" waText>Linear and Swing &mdash; classic timing functions for simple animations</p>
					<p waBody="s" waColorText="quiet" waText>Angular 21 integration &mdash; auto-loaded via PageConfigurator with browser-easing.js</p>
					<p waBody="s" waColorText="quiet" waText>Zero configuration &mdash; auto-registered via ServiceLoader SPI</p>
					<p waBody="s" waColorText="quiet" waText>CRTP fluent API for animation configuration</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<div waCaption="s" waFontWeight="semibold" waText>EXAMPLES</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Apply Easing Effects</h4>
						<p waBody="s" waColorText="quiet" waText>Use type-safe easing enum for animation timing functions.</p>
						<markdown [data]="mdContent_91" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
					<markdown [data]="mdContent_92" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINT DETAILS</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IPageConfigurator</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>EasingPageConfigurator auto-registers browser-easing.js for Angular integration</p>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINTS</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>PREREQUISITES</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://easings.net/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/Easing</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>